import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Sparkles, ListChecks, Settings2, Layers, BarChart3 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useFirma } from "../context/FirmaContext";
import { ymd } from "./pulizie/helpers";
import PulizieDashboard from "./pulizie/PulizieDashboard";
import PulizieChecklist from "./pulizie/PulizieChecklist";
import PuliziePianificazione from "./pulizie/PuliziePianificazione";
import PulizieConfig from "./pulizie/PulizieConfig";

const TABS = [
  ["dashboard", "Dashboard", BarChart3],
  ["checklist", "Checklist giornaliera", ListChecks],
  ["pian", "Pianificazione", Layers],
  ["config", "Configurazione mappa", Settings2],
];

export default function Pulizie() {
  const { selectedStructure, structures = [], companyLogo } = useAuth();
  const { identity, activeOperatore } = useFirma();
  const [tab, setTab] = useState(() => new URLSearchParams(window.location.search).get("tab") || "dashboard");
  const [data, setData] = useState(ymd(new Date()));
  const noStruct = !selectedStructure || selectedStructure === "all";

  const { data: operatori = [] } = useQuery({
    enabled: !noStruct,
    queryKey: ["pul-ops", selectedStructure],
    queryFn: async () => (await api.get("/firma/operatori", { params: { structure_id: selectedStructure } })).data,
  });

  if (noStruct) return <div className="p-8"><h1 className="text-2xl font-head font-bold mb-2">Area Pulizie</h1><p className="text-muted-foreground">Seleziona una struttura dal menu in alto per gestire le pulizie.</p></div>;

  const strutturaNome = (structures.find((s) => s.id === selectedStructure) || {}).nome || "";

  return (
    <div className="p-4 sm:p-6 lg:px-10">
      <div className="flex items-center gap-3 mb-5">
        <div className="w-11 h-11 rounded-xl bg-sky-100 grid place-items-center"><Sparkles className="text-sky-600" size={22} /></div>
        <div><h1 className="text-2xl font-head font-bold">Area Pulizie</h1><p className="text-sm text-muted-foreground">{strutturaNome ? `${strutturaNome} · ` : ""}Dashboard, checklist con verifica task, pianificazione e configurazione</p></div>
      </div>

      <div className="flex gap-2 mb-6 overflow-x-auto pb-1 -mx-1 px-1">
        {TABS.map(([id, label, Icon]) => (
          <button key={id} onClick={() => setTab(id)} data-testid={`pul-tab-${id}`} className={`px-3.5 py-2 rounded-lg font-semibold text-sm flex items-center gap-2 whitespace-nowrap shrink-0 transition-colors ${tab === id ? "bg-sky-600 text-white" : "bg-white border hover:bg-slate-50"}`}>
            <Icon size={16} /> {label}
          </button>
        ))}
      </div>

      {tab === "dashboard" && <PulizieDashboard structureId={selectedStructure} strutturaNome={strutturaNome} companyLogo={companyLogo} />}
      {tab === "checklist" && <PulizieChecklist structureId={selectedStructure} data={data} setData={setData} operatori={operatori} identity={identity} activeOperatore={activeOperatore} />}
      {tab === "pian" && <PuliziePianificazione structureId={selectedStructure} operatori={operatori} />}
      {tab === "config" && <PulizieConfig structureId={selectedStructure} operatori={operatori} />}
    </div>
  );
}
